import { type SearchRequest } from '@searchkit/api';

// `request.type` is the documented signal, but searchkit 4.16 never sets it, so `hitsPerPage === 0`
// is the real check — see tests/isFacetOnlyRequest.test.ts.
export function isFacetOnlyRequest(searchRequest?: Pick<SearchRequest, 'request'>): boolean {
  const request = searchRequest?.request;
  if (!request) return false;
  if (request.type === 'facet') return true;

  return request.params?.hitsPerPage === 0;
}
